import React from 'react';

import { MyPortfolioContextProvider } from '../myTasks2/components/Tabs/MyPortfolio/store/myPortfolio.store';
import WorkspaceContainer from './WorkspaceContainer';

interface WorkspaceProps {
  isReportsEnabled?: boolean;
}

const Workspace: React.FC<WorkspaceProps> = ({ isReportsEnabled }) => {
  return (
    <MyPortfolioContextProvider>
      <WorkspaceContainer isReportsEnabled={isReportsEnabled} />
    </MyPortfolioContextProvider>
  );
};

export default Workspace;
